import { useAuth } from 'contexts/auth';
import PageLayout from 'pages/QuizSubmissions/PageLayout';
import PageProvider from 'pages/QuizSubmissions/PageProvider';
import { useParams } from 'react-router-dom';

const QuizSubmissionsPage = () => {
    const { id } = useParams();
    const { auth } = useAuth();
    return (
        <PageProvider key={JSON.stringify([id, auth.course_id, auth.owner_account_id, auth.role])}>
            <PageLayout />
        </PageProvider>
    );
};

export default QuizSubmissionsPage;
